import Heading from "../components/Heading";
import React, {useCallback, useState} from "react";
import {useAdmin} from "../contexts/AdminContext";
import Loader from "../components/Loader";
import SubscriptionOverview from "../compositions/Subscription/SubscriptionOverview";
import SubscriptionAdministration from "../compositions/Subscription/SubscriptionAdministration";
import Registration from "../compositions/Subscription/Registration";
import Login from "../compositions/Subscription/Login";
import SubscribePlan from "../compositions/Subscription/SubscribePlan";
import ChangePlan from "../compositions/Subscription/ChangePlan";
import ChangeCompanyData from "../compositions/Subscription/ChangeCompanyData";
import {useTranslation} from "react-i18next";
import PasswordReset from "../compositions/Subscription/PasswordReset";

const Subscription = () => {
    const [page, setPage] = useState<string>('overview')
    const {user, loggingIn} = useAdmin()

    const changePage = useCallback((p: string) => {
        setPage(p)
    }, [])
    const {t} = useTranslation(['settings'])
    return (
        <div>
            <Heading level={2} classes={'mt-4'}>{t("subscription.subscription")}</Heading>
            {loggingIn &&
                <div className={'w-100 d-flex justify-content-center'}>
                    <Loader isLoading={loggingIn} size={'l'}/>
                </div>
            }
            {!loggingIn &&
                <>
                    {(page === 'overview' && !user) && <SubscriptionOverview changePage={changePage}/>}
                    {(page === 'overview' && user) && <SubscriptionAdministration changePage={changePage}/>}
                    {page === 'register' && <Registration changePage={changePage}/>}
                    {page === 'login' && <Login changePage={changePage}/>}
                    {page === 'password_reset' && <PasswordReset changePage={changePage}/>}
                    {page === 'subscribe' && <SubscribePlan changePage={changePage}/>}
                    {page === 'change_plan' && <ChangePlan changePage={changePage}/>}
                    {page === 'change_company' && <ChangeCompanyData changePage={changePage}/>}
                </>
            }
        </div>
    )
}

export default Subscription
